import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    text-align: center;
`;

export const ContentButtons = styled(motion.div)`
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;

    a {
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        letter-spacing: -0.5px;
        text-decoration-line: underline;
        color: #ffffff;
    }
`;
export const ContentTitle = styled(motion.h1)`
    font-family: 'Alliance No.1', sans-serif;
    font-weight: bold;
    font-size: 70px;
    line-height: 80px;
    letter-spacing: -2px;
    margin-bottom: 40px;
    color: #fff;
    margin-top: 0;

    @media (max-width: 767px) {
        font-size: 35px;
        line-height: 40px;
        letter-spacing: -1.5px;
        margin-bottom: 30px;
    }
`;
